export var footerType;
(function (footerType) {
    footerType["DEFAULT"] = "default";
    footerType["SHORT"] = "default_short";
    footerType["SHORT_WITHOUT_SOCIAL"] = "default_short_without_social";
})(footerType || (footerType = {}));
